import { html } from "lit";
import {
    dummyStories,
    TeaserStoryTemplate,
} from "../../partial-templates/teaser/story/teaser-story.templates";

interface ViewAllBlockProps {
    shadow?: boolean;
    asButton?: boolean;
    tab: string;
    icon?: string;
    text?: string;
}

const renderViewAllBlock = ({
    shadow,
    asButton,
    tab,
    icon = "",
    text,
}: ViewAllBlockProps) => {
    const classNames = ["ux-iws-view-all-block"];
    if (shadow) classNames.push("ux-iws-view-all-block--with-shadow");
    if (asButton) classNames.push("ux-iws-view-all-block--as-button");
    const iconHtml =
        icon !== "" ? html`<ux-icon name="${icon}"></ux-icon>` : "";
    return html`
        <a class="${classNames.join(" ")}" href="#" data-ux-tab-target="${tab}">
            ${iconHtml}
            <span class="ux-u-text-bold ux-u-text-align--center">${text}</span>
        </a>
    `;
};

export function renderStoriesSlider() {
    const randomStories = [dummyStories[0], dummyStories[1], dummyStories[2]];
    return html`
        <ux-slider
            slides-auto-height
            slides-overflow-visible
            faded-sides
            breakpoint-s="767"
            breakpoint-m="1200"
            breakpoint-l="1439"
            container-width-s="80%"
            container-width-m="80%"
            container-width-l="80%"
            container-width-xl="80%"
            visible-slides-s="1"
            visible-slides-m="2"
            visible-slides-l="3"
            visible-slides-xl="4"
            space-between-s="10"
            space-between-m="30"
            space-between-l="30"
            space-between-xl="30"
            arrows-follow-img=".ux-iws-teaser-story"
            container-classes="ux-u-background-grey-faded-vertical"
        >
            ${randomStories.map((story) => {
                return html`
                    <!-- BEGIN slide -->
                    <ux-slider-slide
                        class="ux-u-margin-top-25 ux-u-margin-l-top-35 ux-u-margin-bottom-40 ux-u-margin-l-bottom-50"
                    >
                        ${TeaserStoryTemplate(story)}
                    </ux-slider-slide>
                    <!-- END slide -->
                `;
            })}
            <!-- BEGIN view all slide -->
            <ux-slider-slide
                class="ux-u-margin-top-25 ux-u-margin-l-top-35 ux-u-margin-bottom-40 ux-u-margin-l-bottom-50"
            >
                ${renderViewAllBlock({
                    tab: "press",
                    icon: "press",
                    text: "Mehr Artikeln zum thema Newsroom",
                })}
            </ux-slider-slide>
            <!-- END view all slide -->
            <ux-slider-pagination
                class="ux-u-margin-top-10"
                slot="pagination"
                bottom-pagination
            >
            </ux-slider-pagination>
        </ux-slider>
    `;
}

interface NewsroomStoryBlockTemplateProps {
    tabs: Array<{
        id: string;
        label: string;
    }>;
}

export const NewsroomStoryBlockTemplate = ({
    tabs,
}: NewsroomStoryBlockTemplateProps) => html`
    <div class="ux-row ux-u-mx-zero">
        <div
            class="ux-u-margin-vertical-35 ux-u-margin-l-vertical-45 ux-u-margin-xl-top-55 ux-u-margin-xl-bottom-60"
        >
            <h2
                class="ux-text-headline ux-text-headline--big ux-u-text-align--center ux-u-margin-bottom-35"
            >
                Stories
            </h2>
            <ux-tab-container
                scroll-when-activated
                active-tab="neue-artikel"
                tab-header-classes="gr-10 push-1 u-floatNone no-gutter"
            >
                ${tabs.map(
                    (tab) => html`
                        <ux-tab
                            name="${tab.label}"
                            tab-id="${tab.id}"
                            class="ux-u-margin-bottom-35"
                        >
                            ${renderStoriesSlider()}
                        </ux-tab>
                    `
                )}
            </ux-tab-container>
        </div>
    </div>
`;
